<style>

#container {
    width: 100%;
    height: 100%;
    margin: 0px;
    font-size: 13px;
}

#pickerBox {
    position: absolute;
    z-index: 9999;
    top: 50px;
    right: 30px;
    width: 300px;
}

#pickerInput {
    width: 200px;
    padding: 5px 5px;
}

#poiInfo {
    background: #fff;
}

.amap_lib_placeSearch .poibox.highlight {
    background-color: #CAE1FF;
}

.amap_lib_placeSearch .poi-more {
    display: none!important;
}

.search-box {
    top: 25px;
    left: 200px;
}

</style>

<template>

<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
    <el-form-item v-for="component in components" v-if="component.prop&&component.prop.visible!=null?component.prop.visible:true&&component.prop.visibleField?(form[component.prop.visibleField]==component.prop.visibleValue):true" :label="component.label?component.label:''"
    :prop="component.field">
        <el-col :span="component.prop&&component.prop.span?component.prop.span:24">
            <component ref="component" :placeholder="component.prop&&component.prop.placeholder?component.prop.placeholder:''" v-if="component.name=='component'&&component.prop&&component.prop.componentName" :dataAlias="component.prop.dataAlias?component.prop.dataAlias:[]"
            @onChanged="onChanged" v-model="form[component.field]" v-bind:is="component.prop.componentName">
                <!-- 组件在 vm.currentview 变化时改变！ -->
            </component>

            <!-- 普通输入 -->
            <el-input v-if="component.name=='el-input'" :placeholder="component.prop&&component.prop.placeholder?component.prop.placeholder:''" type="age" v-model="form[component.field]" auto-complete="off">
            </el-input>

            <!-- 普通选择框 -->
            <template v-if="component.name=='el-select'">
                <el-select :multiple="component.prop.multiple?component.prop.multiple:false" :filterable="component.prop.filterable?'filterable':''" :allow-create="component.prop.allowCreate?true:false" v-model="form[component.field]" :placeholder="component.prop&&component.prop.placeholder?component.prop.placeholder:''">
                    <template v-if="component.prop&&component.prop.options">
                        <el-option v-for="option in component.prop.options" :label="component.prop.optionsName?option[component.prop.optionsName]:option['label']" :value="component.prop.optionsValue?option[component.prop.optionsValue]+'':option['value']+''">
                        </el-option>
                    </template>
                </el-select>
            </template>

            <!-- 多图上传组件 -->
            <el-upload v-if="component.name=='el-upload'" ref="upload" :action="baseUrl+'upload/uploadPic'" list-type="picture-card" :data="{floder:component.prop&&component.prop.floder?component.prop.floder:'default',field:component.field}" :limit="component.prop.limit?component.prop.limit:1"
            :multiple="component.prop.multiple?component.prop.multiple:false" :on-remove="handleRemove" :file-list="form[component.field]" :on-success="handleMultipleSuccess" :on-change="handleMultipleChange" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview">
                <i class="el-icon-plus"></i>
            </el-upload>

            <!-- 单图上传组件 -->
            <el-upload v-if="component.name=='el-upload-single'" class="avatar-uploader" ref="upload" :action="baseUrl+'upload/uploadPic'" :show-file-list="false" list-type="picture-card" :before-upload="beforeAvatarUpload" :data="{floder:component.prop&&component.prop.floder?component.prop.floder:'default',field:component.field}"
            :limit="component.prop.limit?component.prop.limit:1" :multiple="component.prop.multiple?component.prop.multiple:false" :on-remove="handleRemove" :file-list="form[component.field]" :on-success="handleSingleSuccess" :on-preview="handlePictureCardPreview">
                <template v-if="form[component.field]&&form[component.field].length">
                    <img v-for="image in form[component.field]" :src="image.url" class="avatar">
                </template>

                <i v-else class="el-icon-plus"></i>
            </el-upload>

            <!-- 多选 -->
            <el-checkbox-group v-if="component.name=='el-checkbox-group'" v-model="form[component.field]">
                <template v-if="component.prop&&component.prop.options">
                    <el-checkbox v-for="option in component.prop.options" name="type" :label="component.prop.optionsValue?option[component.prop.optionsValue]+'':option['value']+''">{{component.prop.optionsName?option[component.prop.optionsName]:option['label']}}</el-checkbox>
                </template>
            </el-checkbox-group>

            <!-- 单选 -->
            <el-radio-group v-if="component.name=='el-radio-group'" v-model="form[component.field]">
                <template v-if="component.prop&&component.prop.options">
                    <el-radio v-for="option in component.prop.options" :label="component.prop.optionsValue?option[component.prop.optionsValue]+'':option['value']+''">
                        {{component.prop.optionsName?option[component.prop.optionsName]:option['label']}}
                    </el-radio>
                </template>
            </el-radio-group>

            <!-- 富渠道编辑器 -->
            <quill-editor v-if="component.name=='quill-editor'" v-model="form[component.field]" ref="myQuillEditor" style="width:100%;">
            </quill-editor>

            <el-amap ref="el-amap" v-if="component.name=='el-amap'" vid="amap" :plugin="plugin" :center="center" :zoom="zoom" class="amap" style="height:400px">
                <el-amap-search-box class="search-box" :default="searchArea" :search-option="searchOption" :on-search-result="onSearchResult" style="position: absolute;">
                </el-amap-search-box>
                <el-amap-marker v-for="marker in markers"  :position="marker.position" :events="marker.events"  :draggable="marker.draggable"></el-amap-marker>
            </el-amap>

        </el-col>
    </el-form-item>
    <el-form-item>
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
        <el-button @click="$emit('onCancel')">取消</el-button>
    </el-form-item>
</el-form>

</template>

<script>

import BasicModel from '../framework/basic/BasicModel'
import Config from '../framework/configs/Config'
import { quillEditor } from 'vue-quill-editor'
import { AMapManager } from 'vue-amap'

export default {
  data () {
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      form: {},
      zoom: 17,
      center: [121.53996, 31.197646],
      markers: [
      ],
      plugin: [{
        pName: 'Scale',
        events: {
          init (instance) {}
        }
      }, {
        pName: 'ToolBar',
        events: {
          init (instance) {}
        }
      }],
      searchArea: '',
      searchOption: {
        citylimit: false
      }
    }
  },
  components: {
    quillEditor
  },
  props: {

    uploadConfig: {
      type: Object,
      default: function () {
        return {
          width: 640,
          height: 480
        }
      }
    },
    formDefault: {
      type: Object,
      default: function () {
        return {}
      }
    },
    id: {
      type: Number,
      default: function () {
        return null
      }
    },
    insertAction: {
      type: String,
      default: function () {
        return 'insert.action'
      }
    },
    editAction: {
      type: String,
      default: function () {
        return 'edit.action'
      }
    },
    selectInfoAction: {
      type: String,
      default: function () {
        return 'selectInfo.action'
      }
    },
    module: {
      type: String,
      default: function () {
        return ''
      }
    },
    rules: {
      type: Object,
      default: function () {
        return {
          channelId: [{
            required: true,
            message: '年龄不能为空'
          }],
          title: [{
            required: true,
            message: '区域不能为空'
          }]
        }
      }
    },
    components: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    id: function () {
      this.selectInfo()
    }
  },
  created: function () {
    if (this.id) {
      this.selectInfo()
    } else {
      let components = this.components
      for (var i = 0; i < components.length; i++) {
        let component = components[i]
        if (component.prop && component.prop.defaultValue) {
          this.$set(this.form, component.field, component.prop.defaultValue)
        }
      }
    }
    let rules = this.rules
  },
  methods: {
    onChanged: function (datas) {
      for (var variable in datas) {
        if (datas.hasOwnProperty(variable)) {
          this.$set(this.form, variable, datas[variable])
        }
      }

      this.$refs['form'].validate()
    },
    onSearchResult (pois) {
      let _this = this

      _this.markers = []
      let latSum = 0
      let lngSum = 0
      if (pois.length > 0) {
        pois.forEach(poi => {
          let { lng, lat } = poi
          lngSum += lng
          latSum += lat
        })
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        }
        _this.center = [center.lng, center.lat]

        _this.$set(_this.form, 'location', [center.lng, center.lat])

        let marker = {
          position: [center.lng, center.lat],
          draggable: true,
          events: {
            dragend: (e) => {
              this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
            }
          }
        }
        this.markers.push(marker)
      }
    },
    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt2M = file.size / 1024 / 1024 < 5
        if (!isLt2M) {
          _this.$message.error('上传头像图片大小不能超过 5MB!')
          reject(new Error('上传头像图片大小不能超过 5M'))
          return
        }
        var isAllow = false
        var reader = new FileReader()
        reader.onload = function (e) {
          var data = e.target.result
          // 加载图片获取图片真实宽度和高度
          var image = new Image()
          image.onload = function () {
            var width = image.width
            var height = image.height
            if (width == _this.uploadConfig.width && height == _this.uploadConfig.height) {
              resolve()
            } else {
              _this.$alert('当前图片为' + width + '*' + height + '，图片为' + _this.uploadConfig.width + '*' + _this.uploadConfig.height + '最为合适，可能会造成图片效果不好！', '警告', {
                confirmButtonText: '知道了',
                type: 'warning',
                callback: action => {
                  resolve()
                }
              })
            }
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
      return promise
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.$data
          let params = JSON.parse(JSON.stringify(this.$data.form))
          let components = this.components
          for (var i = 0; i < components.length; i++) {
            let component = components[i]
            if (component.name == 'el-upload' || component.name == 'el-upload-single') {
              let datas = params[component.field]
              if (!datas) {
                continue
              }
              let newData = []
              for (var j = 0; j < datas.length; j++) {
                let data = datas[j]
                newData.push(data.name)
              }
              params[component.field] = newData
            }
          }
          // 将数组变成字符串
          for (var fieldName in params) {
            if (params[fieldName] instanceof Array) {
              params[fieldName] = params[fieldName].join(',')
            }
          }
          if (this.markers.length > 0) {
            let dataArrary = this.markers[0].position
            params.longitude = dataArrary[0]
            params.latitude = dataArrary[1]
          }

          let _this = this
          let listener = {
            success: function (dataInfo) {
              _this.$emit('onSuccess', dataInfo)
              _this.$message({
                message: _this.id ? '修改成功！' : '添加成功！',
                type: 'success'
              })
              if (!_this.id) {
                _this.resetForm()
              }
              _this.$emit('onSubmit', dataInfo)
            },
            error: function () {
              _this.$message({
                message: _this.id ? '修改失败！' : '添加失败！',
                type: 'error'
              })
              _this.$emit('onError')
            }
          }
          let formDefault = JSON.parse(JSON.stringify(this.formDefault))
          let allParams = Object.assign(formDefault, params)
          if (this.id) {
            allParams.id = this.id
            BasicModel.post(this, this.module + '/' + this.editAction, allParams, listener)
          } else {
            BasicModel.post(this, this.module + '/' + this.insertAction, allParams, listener)
          }
        } else {
          return false
        }
      })
    },
    selectInfo: function () {
      let _this = this
      let params = {
        id: this.id
      }
      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          if (!datas) {
            return
          }
          _this.bindData(datas)
        }
      }
      BasicModel.get(this, this.module + '/' + this.selectInfoAction, params, listener)
    },
    bindNatureData: function (data) {
      for (var variable in data) {
        if (data.hasOwnProperty(variable)) {
          this.$set(this.form, variable, data[variable])
        }
      }
    },
    bindData: function (datas) {
      let _this = this
      // 查询组建中需要将字符串数组转成数组的类
      let components = _this.components
      for (var i = 0; i < components.length; i++) {
        let component = components[i]

        if (!datas[component.field]) {
          continue
        }
        if (component.name == 'el-select') {
          _this.form[component.field] = datas[component.field].split(',')
        } else if (component.name == 'el-upload' || component.name == 'el-upload-single') {
          let images = datas[component.field].split(',')
          let formatImages = []
          for (var j = 0; j < images.length; j++) {
            let image = images[j]
            formatImages.push({
              name: image,
              url: _this.baseImageUrl + image,
              field: component.field
            })
          }
          _this.$set(_this.form, component.field, formatImages)
          // _this.form[component.field] = formatImages ;
        } else if (component.name == 'el-radio-group') {
          // 在此将值拼接为字符串
          _this.$set(_this.form, component.field, datas[component.field] + '')
        } else if (component.name == 'el-amap') {
          let location = []
          location.push(datas['longitude'])
          location.push(datas['latitude'])
          _this.center = location
          _this.markers = []
          let marker = {
            position: location,
            draggable: true,
            events: {
              dragend: (e) => {
                this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
              }
            }
          }
          _this.markers.push(marker)
        } else {
          _this.$set(_this.form, component.field, datas[component.field])
          // _this.form[component.field] = datas[component.field]
        }
      }
    },
    resetForm () {
      let that = this
      that.searchArea = ''
      this.$refs['form'].resetFields()
      let components = this.components
      for (var i = 0; i < components.length; i++) {
        let component = components[i]
        if (component.name == 'el-upload' || component.name == 'el-upload-single') {
          // 清空上传列表
          let uploads = this.$refs['upload']
          for (var j = 0; j < uploads.length; j++) {
            let upload = uploads[j]
            upload.clearFiles()
          }
          this.$set(this.form, component.field, [])
        } else if (component.name == 'el-amap') {
          let item = this.$refs['el-amap'][0]
          let instance = item.$$getInstance()

          instance.destroy()
        } else if (component.name == 'component') {
          // 清空上传列表
          let components = this.$refs['component']
          for (var j = 0; j < components.length; j++) {
            let component = components[j]
            if (component.clear) {
              component.clear()
            }
          }
        }
      }
    },
    handleRemove (file, fileList) {
      this.form[file.field] = fileList
    },
    handleSingleSuccess (response) { // 单个图片 上传成功钩子
      this.imageUrl = response.datas
      this.$set(this.form, response.field, [{
        name: response.datas,
        url: this.baseImageUrl + response.datas,
        field: response.field
      }])
    },
    handleMultipleChange (response) {},
    handleMultipleSuccess (response) { // 多个图片 上传成功钩子
      this.imageUrl = response.datas
      if (!this.form[response.field]) {
        this.$set(this.form, response.field, [{
          name: response.datas,
          url: this.baseImageUrl + response.datas,
          field: response.field
        }])
        this.$refs['form'].validate((valid) => {
          if (valid) {
            return true
          } else {
            return false
          }
        })
      } else {
        this.form[response.field].push({
          name: response.datas,
          url: this.baseImageUrl + response.datas,
          field: response.field
        })
        this.$refs['form'].validate((valid) => {
          if (valid) {
            return true
          } else {
            return false
          }
        })
      }
    }
  }
}

</script>
